import styled from 'styled-components';

export const StyledCreditDecisionBadgeButton = styled.button<{ $isFinanceMethodMatch?: boolean }>(({ $isFinanceMethodMatch }) => ({
    backgroundColor: 'transparent',
    border: 'none',
    cursor: $isFinanceMethodMatch ? 'pointer' : 'default',
    padding: '0 !important',
    margin: '0 !important',
    fontSize: 'inherit !important',
    fontWeight: 'inherit !important'
}));
